import * as React from 'react';
import { ESocialType } from '../../types/social';
import { SocialIconApple, SocialIconFb, SocialIconG, SocialIconMail, SocialIconOk, SocialIconVk } from './social_icons';
import cn from 'classnames';
import * as styles from './styles.css';
var infoArray = [{
  type: ESocialType.VK,
  icon: SocialIconVk,
  className: styles['btn-vk'],
  title: 'ВКонтакте'
}, {
  type: ESocialType.Facebook,
  icon: SocialIconFb,
  className: styles['btn-fb'],
  title: 'Facebook'
}, {
  type: ESocialType.Google,
  icon: SocialIconG,
  className: styles['btn-google'],
  title: 'Google'
}, {
  type: ESocialType.OK,
  icon: SocialIconOk,
  className: styles['btn-ok'],
  title: 'Одноклассники'
}, {
  type: ESocialType.MailRu,
  icon: SocialIconMail,
  className: styles['btn-mailru'],
  title: 'Почта Mail.Ru'
}, {
  type: ESocialType.AppleID,
  icon: SocialIconApple,
  className: styles['btn-appleid'],
  title: 'Apple ID'
}];
export function SocialButton(_ref) {
  var type = _ref.type,
      dataMark = _ref.dataMark,
      onClick = _ref.onClick;
  var info = React.useMemo(function () {
    return infoArray.find(function (info) {
      return info.type === type;
    }) || {
      title: 'Показать ещё'
    };
  }, [type]);
  var icon = React.useMemo(function () {
    if (!info.icon) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null));
    }

    var IconComponent = info.icon;
    return /*#__PURE__*/React.createElement(IconComponent, null);
  }, [info]);
  var handleClick = React.useCallback(function () {
    return onClick(type);
  }, [type, onClick]);
  return /*#__PURE__*/React.createElement("button", {
    className: cn(styles['btn'], !type && styles['btn-show-more'], info && info.className),
    title: info.title,
    "data-mark": dataMark,
    onClick: handleClick,
    type: "button"
  }, icon);
}